import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { authGuard } from './auth-guard';
import { locationGuard } from './location-guard';
import { moduleGuard } from './module-guard';
import { organizationGuard } from './organization-guard';
import { permissionGuard } from './permission-guard';
import { platformHostGuard } from './platform-host-guard';
import { sessionGuard } from './session-guard';
import { superuserGuard } from './superuser-guard';

type Guard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
) => NavigationGuardReturn | Promise<NavigationGuardReturn>;

/**
 * Композиция guards - выполняются последовательно
 * Если guard возвращает redirect/false, цепочка прерывается и результат уходит роутеру
 */
export const composeGuards = (guards: Guard[]) => {
  return async (to: RouteLocationNormalized, from: RouteLocationNormalized): Promise<NavigationGuardReturn> => {
    for (const guard of guards) {
      const result = await guard(to, from);

      if (result !== undefined && result !== true) {
        return result;
      }
    }

    return true;
  };
};

/**
 * Список всех navigation guards в порядке выполнения
 * sessionGuard должен быть первым для инициализации сессии
 */
export const navigationGuards = [
  sessionGuard,
  authGuard,
  platformHostGuard,
  superuserGuard,
  organizationGuard,
  locationGuard,
  moduleGuard,
  permissionGuard,
];
